import { Injectable } from "@angular/core";
import { IAMAccountCredentialsDownloadCmd } from "@youm-front/iam-account/domain";

@Injectable()
export class IAMAccountCredentialsService {
  iamAccountCredentialsDownload(
    iamAccountCredentialsDownloadCmd: IAMAccountCredentialsDownloadCmd
  ): void {
    const { account } = iamAccountCredentialsDownloadCmd.value;

    const { identity, password } = account.value;
    if (!password) {
      throw new Error("IAM Account password not defined");
    }

    const csvHeader = "identity,password\n";
    const csvBody = `${identity},${password}\n`;

    const hiddenElement = document.createElement("a");
    hiddenElement.href =
      "data:text/csv;charset=utf-8," + encodeURI(csvHeader + csvBody);
    hiddenElement.target = "_blank";
    hiddenElement.download = `youm_iam_${identity}_credentials.csv`;
    hiddenElement.click();
  }
}
